import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Settings = () => {
  return (
    <div className="p-6 h-full flex flex-col pb-24 md:pb-6">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">System Configuration</h1>
      </header>

      <div className="flex-1 space-y-6 overflow-y-auto scrollbar-hide">
        <div className="glass-panel p-5 rounded-2xl">
          <h2 className="text-sm font-semibold text-teal-400 uppercase tracking-wider mb-4">Preferences</h2>
          <div className="space-y-4">
            {['Push Notifications', 'Automated Energy Reports', 'Auto-assign Chores'].map((setting, i) => (
              <div key={i} className="flex items-center justify-between py-2 border-b border-slate-700/50 last:border-0">
                <span className="text-slate-300">{setting}</span>
                <div className={`w-10 h-5 rounded-full relative cursor-pointer ${i === 2 ? 'bg-slate-700' : 'bg-teal-500'}`}>
                  <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${i === 2 ? 'left-0.5' : 'left-5'}`} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="glass-panel p-5 rounded-2xl">
          <h2 className="text-sm font-semibold text-teal-400 uppercase tracking-wider mb-4">Household Members</h2>
          <div className="flex items-center gap-4">
            <button className="w-12 h-12 rounded-full border-2 border-dashed border-slate-600 flex items-center justify-center text-slate-400 hover:text-teal-400 hover:border-teal-400 transition-colors">
              <SafeIcon icon="FiPlus" />
            </button>
            <span className="text-sm text-slate-400">Invite new member</span>
          </div>
        </div>
      </div>

      <div className="mt-8 text-center border-t border-slate-800 pt-6">
        <p className="text-xs text-slate-500 font-mono tracking-widest">SYSTEM V2.4.1</p>
        <p className="text-sm text-slate-400 mt-2">Made by LingLink AI and DigLab AI</p>
      </div>
    </div>
  );
};

export default Settings;